import React, { useState, useEffect, useRef } from "react";
import { usePsChat } from "../../../context/PsChatMessageContext";

const RestrictUserAlert = ({
  isOpen,
  onClose,
  threadId,
  userId,
  currentlyRestricted = false
}) => {
  const { blockUser } = usePsChat();
  const [reason, setReason] = useState("Inappropriate behavior");
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose?.();
      }
    };
    if (isOpen) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, onClose]);

  const handleSubmit = async (restrictValue) => {
    if (!threadId || !userId) return onClose?.();

    setSaving(true);
    try {
      const finalReason = note ? `${reason} — ${note}` : reason;
      await blockUser(threadId, restrictValue, finalReason, userId);
      onClose?.();
    } catch (err) {
      console.error("[RestrictUserAlert] Failed:", err);
    } finally {
      setSaving(false);
    }
  };

  const handleRestrict = () => handleSubmit(true);
  const handleUnrestrict = () => handleSubmit(false);

  const handleCancel = () => {
    onClose?.();
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="alert-overlay" />

      <div
  className="alert-window"
  ref={modalRef}
  onClick={(e) => e.stopPropagation()}
>

        <h2>{currentlyRestricted ? "Unblock User" : "Block User"}</h2>

        <p>
          {currentlyRestricted
            ? "User interaction access restored."
            : "User's interaction will be restricted."}
        </p>

        <label>Reason:</label>
        <select
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          disabled={saving}
        >
          <option>Inappropriate behavior</option>
          <option>Harassment or abuse</option>
          <option>Scam or fraud suspicion</option>
          <option>Spam or unwanted contact</option>
          <option>Other</option>
        </select>

        <label>Leave a Note (optional):</label>
        <textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Add optional admin notes..."
          disabled={saving}
        />

        <div className="alert-actions">
          <button onClick={handleCancel} disabled={saving}>
            Cancel
          </button>

          {currentlyRestricted ? (
            <button
              className="btn-secondary"
              onClick={handleUnrestrict}
              disabled={saving}
            >
              {saving ? "Updating..." : "Unrestrict"}
            </button>
          ) : (
            <button
              className="btn-danger"
              onClick={handleRestrict}
              disabled={saving}
            >
              {saving ? "Restricting..." : "Restrict User"}
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default RestrictUserAlert;
